import axios, { AxiosError } from 'axios';
import store from 'store';

import { useQuery } from '@tanstack/react-query';

const getProposalPublishersList: {
  (): Promise<any>;
} = async () => {
  const header = {
    Authorization: `Token ${store.getState().user.token}`,
  };

  const res = await axios({
    baseURL: process.env.REACT_APP_ADSERVER_ENDPOINT + '/publishers',
    method: 'GET',
    headers: header,
  });
  return res;
};

export const useGetProposalPublishersList = (): {
  data: any;
  status: string;
  isLoading: boolean;
} => {
  const { data, status, isLoading } = useQuery<any, AxiosError>({
    queryKey: ['proposalPublishersList'],
    queryFn: () => getProposalPublishersList(),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    data,
    status,
    isLoading,
  };
};
